import style from '../style'
import { ReactTableRowId } from '../models/gridReactTable'

export function isOverflown(element: Element): boolean {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  )
}

export function findParentElementFromClassName(
  elem: Element,
  className: string
): Element | null {
  return elem.closest(`.${className}`)
}

export function getRowEl(cell?: Element | null): HTMLElement | null {
  if (!cell) {
    return null
  }
  return findParentElementFromClassName(
    cell as HTMLDivElement,
    style.row
  )! as HTMLElement
}

// TODO remove
export function isGridCellRoot(elem: Element | null): boolean {
  return elem != null && elem.classList.contains(style.cell)
}

export function isGridHeaderCellRoot(elem: Element | null): boolean {
  return elem != null && elem.classList.contains(style.columnHeader)
}

function escapeOperandAttributeSelector(operand: string): string {
  return operand.replace(/["\\]/g, '\\$&')
}

export function getGridColumnHeaderElement(root: Element, field: string) {
  return root.querySelector<HTMLDivElement>(
    `[role="columnheader"][data-field="${escapeOperandAttributeSelector(
      field
    )}"]`
  )
}

function getGridRowElementSelector(id: ReactTableRowId): string {
  return `.${style.row}[data-id="${escapeOperandAttributeSelector(
    String(id)
  )}"]`
}

export function getGridRowElement(root: Element, id: ReactTableRowId) {
  return root.querySelector<HTMLDivElement>(getGridRowElementSelector(id))
}

export function getGridCellElement(
  root: Element,
  { id, field }: { id: ReactTableRowId; field: string }
) {
  const rowSelector = getGridRowElementSelector(id)
  const cellSelector = `.${
    style.cell
  }[data-field="${escapeOperandAttributeSelector(field)}"]`
  const selector = `${rowSelector} ${cellSelector}`
  return root.querySelector<HTMLDivElement>(selector)
}

export function findGroupHeaderElementsFromField(
  elem: Element,
  field: string
): Element[] {
  return Array.from(
    elem.querySelectorAll<HTMLDivElement>(`[data-fields*="|-${field}-|"]`) ?? []
  )
}

export function getFieldFromHeaderElem(colCellEl: Element): string {
  return colCellEl.getAttribute('data-field')!
}

export function findGridCellElementsFromCol(col: HTMLElement) {
  const root = findParentElementFromClassName(col, style.root)
  if (!root) {
    throw new Error('The root element is not found.')
  }

  const ariaColIndex = col.getAttribute('aria-colindex')
  if (!ariaColIndex) {
    return []
  }

  const colIndex = Number(ariaColIndex) - 1
  const cells: Element[] = []

  const renderedRowElements = root.querySelectorAll(`.${style.row}`)

  const renderedFooterElement = root.querySelectorAll(
    `.${style.columnFooterRow}`
  )

  const renderedSkeletonElement = root.querySelectorAll(`.${style.skeletonRow}`)

  renderedSkeletonElement.forEach(rowElement => {
    const rowId = rowElement.getAttribute('data-id')
    if (!rowId) {
      return
    }
    const cell = rowElement.querySelector(`[data-colindex="${colIndex}"]`)
    if (cell) {
      cells.push(cell)
    }
  })

  renderedFooterElement.forEach(rowElement => {
    const rowId = rowElement.getAttribute('data-id')
    if (!rowId) {
      return
    }
    const cell = rowElement.querySelector(`[data-colindex="${colIndex}"]`)
    if (cell) {
      cells.push(cell)
    }
  })

  renderedRowElements.forEach(rowElement => {
    const rowId = rowElement.getAttribute('data-id')
    if (!rowId) {
      return
    }

    const cell = rowElement.querySelector(`[data-colindex="${colIndex}"]`)
    if (cell) {
      cells.push(cell)
    }
  })

  return cells
}
